/**
 * Habit Tracker's own vocabulary, mapped onto the panel-wide design tokens in
 * component/common/designSystem/theme.js.
 */
import {
  CHART_COLORS,
  toneChip,
  toneColor,
  toneColors,
  toneLookup
} from '../../component/common/designSystem';

const statusTone = toneLookup({
  active: 'success',
  paused: 'warning',
  completed: 'info',
  archived: 'neutral'
});

export const habitStatusColor = (status) => toneColor(statusTone(status));
export const habitStatusChipClass = (status) => toneChip(statusTone(status));

/** Status donut — same order the API returns: active, paused, completed, archived. */
export const HABIT_STATUS_COLORS = toneColors(['success', 'warning', 'info', 'neutral']);

/** Shoorah catalog habits vs users' own. */
export const HABIT_SOURCE_COLORS = toneColors(['brand', 'accent']);

/** Daily / weekly / monthly, most frequent first. */
export const HABIT_FREQUENCY_COLORS = toneColors(['teal', 'warning', 'orange']);

/**
 * What happened to a logged activity: completed → partial → skipped → missed.
 * Not a ramp but a verdict, so each bucket takes its semantic tone.
 */
export const HABIT_OUTCOME_COLORS = toneColors(['success', 'warning', 'neutral', 'danger']);

/**
 * Ordered ramps for the distribution charts. Each is a sequence rather than a
 * set of categories, so they get a ramp instead of the categorical palette —
 * and each has exactly as many colours as its band list has bands, so a slice
 * never borrows its neighbour's meaning.
 */

// Current streak, No streak → 15+ days.
export const STREAK_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.amber,
  CHART_COLORS.blue,
  CHART_COLORS.brand,
  CHART_COLORS.greenDeep
];

/**
 * Lifetime completions on one habit, Never completed → 50+ times. The bottom
 * band is grey rather than red: a habit nobody started isn't a failure to
 * punish, it's the gap the whole card exists to surface.
 */
export const ADHERENCE_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.orange,
  CHART_COLORS.amber,
  CHART_COLORS.green,
  CHART_COLORS.greenDeep
];

// How many habits one person runs at once: 1 → 7+.
export const HABITS_PER_USER_RAMP = [
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.greenDeep,
  CHART_COLORS.green
];

// Days completed in the last 30: fewest → most.
export const CONSISTENCY_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.amber,
  CHART_COLORS.blue,
  CHART_COLORS.greenDeep
];

// Early Morning → Night, running dawn → dusk so the axis reads as a day.
export const TIME_OF_DAY_RAMP = [
  CHART_COLORS.amber,
  CHART_COLORS.orange,
  CHART_COLORS.teal,
  CHART_COLORS.brand,
  CHART_COLORS.moss
];
